import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportEstadoTransmisionEventos(ctx: any, vrs: number): any {
    /* vm.dateHour() y datee; //Obtiene el chkDateHour para separar las columnas de fecha y hora*/

    var exportFileEx = [];
    var bol_datos_ex = false;
    var column_config:Columns[] = [];

    var estado_cell_ch_width = "Estado".length;

    var duracion_cell_ch_width = "Duracion".length;
    var velocidad_cell_ch_width = "Velocidad".length;
    var ignicion_cell_ch_width = "Ignicion".length;
    var pc_cell_ch_width = "Punto cercano".length;
    var geocerca_cell_ch_width = "Geocerca".length;
    var referencia_cell_ch_width = "Referencia".length;
    var ubicacion_cell_ch_width = "Ubicacion".length;


    var table_width =  ctx.chkDateHour? 17:13;
    var vehiculo_width = 4;

    var nom_inf = ctx.report_data.rep_title; //"REPORTE DE EXCESOS DE VELOCIDAD";

    var allRows: AllRows[] = [
        {
          cells: [
            { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
          ],
          height: ctx.headerRowsHeight,
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];



    ctx.sortedData.forEach((table_data: any) => {
      if(table_data[1].length > 0){
        column_config = [];
        var p_cercano_width = 155;
        var z_cercana_width = 165;

        bol_datos_ex = true;

        var nom_vehi = table_data[0][1];
        /* if (vm.optionR() == 28) {
            vm.period = data[3][10];
            ruta  = "RUTA : " + data[3][11];

            if (vrs == 1) {
                cc = cc + 1;
                nom_vehi = nom_vehi + " - " +cc;
            }
        } */

        /* Table Header */

        var rows: AllRows[] = [
          {
            cells: [
              { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
              { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
            ],
            height: ctx.subHeaderHeight,
          },
          {
            cells: [
              { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
              { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
            ],
            height: ctx.subHeaderContentHeight,
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        /* Table Body */

        var cellsCampos = [];

        //----------- CABECERA ------------
          cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Estado", ...ctx.colHeaderConfig });

          if (ctx.chkDateHour) {
            cellsCampos.push({ value: "Fecha Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Hora Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Fecha Fin", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Hora Fin", ...ctx.colHeaderConfig });
          } else {
            cellsCampos.push({ value: "Fecha/Hora de Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Fecha/Hora de Fin", ...ctx.colHeaderConfig });
          }

          if (ctx.chkDateHour) {
            cellsCampos.push({ value: "Fecha Servidor Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Hora Servidor Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Fecha Servidor Fin", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Hora Servidor Fin", ...ctx.colHeaderConfig });
          } else {
            cellsCampos.push({ value: "Fecha/Hora Servidor de Inicio", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Fecha/Hora de Fin", ...ctx.colHeaderConfig });
          }

          cellsCampos.push({ value: "Duración", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Velocidad", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Ignición", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Geocerca", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Referencia", ...ctx.colHeaderConfig });
          cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig });


        rows.push({
          cells: cellsCampos,
          height: ctx.colsHeaderHeight,
        });

        //----------- CONTENIDO / FILAS ------------

        table_data[1].forEach((item: { latitud: number; longitud: number; nombre: any; fecha_tracker: any; fecha_tracker_fin: any; fecha_servidor: any; fecha_servidor_fin: any; PC: any; descripcion_evento: any; tramo: any; referencia: any; duracion_servidor: string; vel_gps:any; ignicion:any; }, index: number) => {
          var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
          var cellsCuerpo = [];

          estado_cell_ch_width = Math.max(estado_cell_ch_width, (item.descripcion_evento??'').toString().length);
          duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion_servidor??'').toString().length);
          velocidad_cell_ch_width = Math.max(velocidad_cell_ch_width, (item.vel_gps??'').toString().length);
          ignicion_cell_ch_width = Math.max(ignicion_cell_ch_width, (item.ignicion??'').toString().length);
          pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
          geocerca_cell_ch_width = Math.max(geocerca_cell_ch_width, (item.tramo??'').toString().length);
          referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
          ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);

          cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.descripcion_evento, ...ctx.bodyRowsConfig });

          if (ctx.chkDateHour) {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_tracker), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha_tracker), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_tracker_fin), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha_tracker_fin), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_tracker), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_tracker_fin), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
          }

          if (ctx.chkDateHour) {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_servidor), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha_servidor), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_servidor_fin), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChs(item.fecha_servidor_fin), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
          } else {
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_servidor), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
            cellsCuerpo.push({ value: ctx.isChe(item.fecha_servidor_fin), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
          }

          cellsCuerpo.push({ value: item.duracion_servidor, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.vel_gps +" km/h", ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.ignicion, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.PC, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.tramo, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ value: item.referencia, ...ctx.bodyRowsConfig });
          // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
          cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });

          rows.push({
            cells:cellsCuerpo,
            height: ctx.bodyRowsHeight,
          });
        });



        // //********************************************* excel version 2 *********************************
        if ( vrs == 2 ) {
          rows.splice(0, ctx.headerRowSpan);
          rows.push(...ctx.spaceBetweenTables);
          allRows = allRows.concat(rows);
        }
        // //********************************************* excel version 2 *********************************

        // //********************************************* excel version 1 *********************************

        if( vrs == 1 ){

            column_config = [
                { width: ctx.w_item },
                { width: ctx.calculateColWidth(estado_cell_ch_width) },
            ];
            if(ctx.chkDateHour){
                column_config.push(
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
          
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                )
            } else {
                column_config.push(
                    { width: ctx.w_date_and_hour },
                    { width: ctx.w_date_and_hour },
          
                    { width: ctx.w_date_and_hour },
                    { width: ctx.w_date_and_hour },
                )
            }

            column_config.push(
                { width: ctx.calculateColWidth(duracion_cell_ch_width) },
                { width: ctx.calculateColWidth(velocidad_cell_ch_width) },
                { width: ctx.calculateColWidth(ignicion_cell_ch_width) },
                { width: ctx.calculateColWidth(pc_cell_ch_width) },
                { width: ctx.calculateColWidth(geocerca_cell_ch_width) },
                { width: ctx.calculateColWidth(referencia_cell_ch_width) },       
                { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
            )
            /* Fin Ancho de Columnas */

            exportFileEx.push({
              freezePane: {
                  rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
                },
              columns: column_config,
              title: nom_vehi,
              rows: rows
            });

            estado_cell_ch_width = "Estado".length;

            duracion_cell_ch_width = "Duracion".length;
            velocidad_cell_ch_width = "Velocidad".length;
            ignicion_cell_ch_width = "Ignicion".length;
            pc_cell_ch_width = "Punto cercano".length;
            geocerca_cell_ch_width = "Geocerca".length;
            referencia_cell_ch_width = "Referencia".length;
            ubicacion_cell_ch_width = "Ubicacion".length;

        }
        // //********************************************* excel version 1 *********************************

      } // if si hay datos del vehiculo
    });

    //NOTA: width * 1.28 (aprox) = Ancho de columna en excel

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;


      column_config = [
        { width: ctx.w_item },
        { width: ctx.calculateColWidth(estado_cell_ch_width) },
      ];
      if(ctx.chkDateHour){
        column_config.push(
          { width: ctx.w_date_ini_fin },
          { width: ctx.w_hour_ini_fin },
          { width: ctx.w_date_ini_fin },
          { width: ctx.w_hour_ini_fin },

          { width: ctx.w_date_ini_fin },
          { width: ctx.w_hour_ini_fin },
          { width: ctx.w_date_ini_fin },
          { width: ctx.w_hour_ini_fin },
        )
      } else {
        column_config.push(
          { width: ctx.w_date_and_hour },
          { width: ctx.w_date_and_hour },

          { width: ctx.w_date_and_hour },
          { width: ctx.w_date_and_hour },
        )
      }
      column_config.push(
        { width: ctx.calculateColWidth(duracion_cell_ch_width) },
        { width: ctx.calculateColWidth(velocidad_cell_ch_width) },
        { width: ctx.calculateColWidth(ignicion_cell_ch_width) },
        { width: ctx.calculateColWidth(pc_cell_ch_width) },
        { width: ctx.calculateColWidth(geocerca_cell_ch_width) },
        { width: ctx.calculateColWidth(referencia_cell_ch_width) },       
        { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
      )

      exportFileEx.push({
        freezePane: {
            rowSplit: ctx.headerRowSpan
          },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });

    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportEstadoTransmisionEventos", exportFileEx);  

    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

  }